import { useCallback, useState } from "react";

// =======================================================
// useAppointmentForm
// -------------------------------------------------------
// Manages appointment form state.
//
// Responsibilities:
// - Store add/edit appointment form values
// - Reset the form
// - Prepare form data for a new appointment
// - Prepare form data for editing an appointment
//
// API calls and modal state remain outside this hook.
// =======================================================

const getEmptyAppointmentData = () => ({
  clientName: "",
  phone: "",
  time: "10:00",
  description: "",
  consultation_image_url: "",
  images: [],
  consultation_subject: "",
  consultation_email: "",
  minRange: "",
  maxRange: "",
  deposit: "",
  duration: "",
  tattoo_category: "",
  appointmentKind: "tattoo",
  chooseDay: false,
  dayId: null,
  artistId: null,
  day: null,
});

const useAppointmentForm = () => {
  const [newAppointmentData, setNewAppointmentData] = useState(
    getEmptyAppointmentData
  );

  // =======================================================
  // Reset Appointment Form
  // -------------------------------------------------------
  // Restores all appointment form values to their defaults.
  // =======================================================

  const resetNewAppointmentData = useCallback(() => {
    setNewAppointmentData(getEmptyAppointmentData());
  }, []);

  // =======================================================
  // Prepare New Appointment
  // -------------------------------------------------------
  // Initializes the form for creating an appointment on
  // the selected day and artist.
  // =======================================================

  const prepareNewAppointment = useCallback(
    (dayId, artistId, day) => {
      setNewAppointmentData({
        ...getEmptyAppointmentData(),
        dayId,
        artistId,
        day,
      });
    },
    []
  );

  // =======================================================
  // Prepare Appointment Edit
  // -------------------------------------------------------
  // Copies an existing appointment into the edit form.
  // =======================================================

  const prepareAppointmentEdit = useCallback(
    (appointment, dayId, day) => {
      setNewAppointmentData({
        project_id: appointment.project_id || null,
        project_title: appointment.project_title || "",
        project_session_note: appointment.project_session_note || "",
        clientName: appointment.clientName || "",
        phone: appointment.phone || "",
        time: appointment.time || "",
        description: appointment.description || "",
        consultation_image_url:
          appointment.consultation_image_url || "",
        images: Array.isArray(appointment.images)
          ? appointment.images
          : [],
        consultation_subject:
          appointment.consultation_subject || "",
        consultation_email:
          appointment.consultation_email || "",
        minRange: appointment.minRange ?? "",
        maxRange: appointment.maxRange ?? "",
        deposit: appointment.deposit ?? "",
        duration: appointment.duration || "",
        tattoo_category: appointment.tattoo_category || "",
        dayId,
        artistId: appointment.artistId || null,
        day,
      });
    },
    []
  );

  return {
    newAppointmentData,
    setNewAppointmentData,
    resetNewAppointmentData,
    prepareNewAppointment,
    prepareAppointmentEdit,
  };
};

export default useAppointmentForm;